import { render, staticRenderFns } from "./AiDeveloper.vue?vue&type=template&id=f62f585a&scoped=true&"
import script from "./AiDeveloper.vue?vue&type=script&lang=js&"
export * from "./AiDeveloper.vue?vue&type=script&lang=js&"
import style0 from "./AiDeveloper.vue?vue&type=style&index=0&id=f62f585a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62f585a",
  null
  
)

export default component.exports